import { Link ,useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import UseGameSvcLstQuery from "Apis/GameSvcLstInqApi";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import "Assets/css/Ctnt.css";
import "Assets/css/Cs.css";
import ImgWithFallback from "Utils/ImgWithFallback";
import { useEffect } from "react";
const CsMainUi = () => {
    const {isLoading,error,data:gameSvcData}:any = UseGameSvcLstQuery();
    const {data: langData}:any = UseLangLstQuery();


    const navigate = useNavigate();
    useEffect(() => {
        navigate('/cs/FaqLst?gameSvcCd=BBO&ctntKindCd=FAQ', { replace: true });
    }, [navigate]);


    // return(
    //     <div className="BgW">
    //     <Helmet>
    //         <title>MGP</title>
    //     </Helmet>
    //     <div className="csMainBnr">
    //         <h1>고객센터</h1>
    //         <p>Customer Support</p>
    //     </div>
    //     <div className="ctntLstWrap csMainLstWrap">
    //         <div className="csMainTitlWrap">
    //             <p>{langData&&langData.CS_MAIN_SUB_TITL_BTN_00}</p>
    //         </div>
    //         <div className="ctntLstContentsWrap">
    //             <ul>
    //                 {gameSvcData&&gameSvcData.map((key:any)=>(
    //                     <li className="gameSvcLstItem">
    //                         <Link to={`/cs/FaqLst?gameSvcCd=${key.gameSvcCd}&ctntKindCd=FAQ`} className="borderNone">
    //                             <div className="thmbImgWrap">
    //                                 <ImgWithFallback src={key.imgUrl.thmbUrl} alt="" />
    //                                 {/* <img src={key.imgUrl.thmbUrl} alt="" /> */}
    //                             </div>
    //                             <div className="textWrap">
    //                                 <h2>{key.gameNm}</h2>
    //                             </div>
    //                         </Link>
    //                     </li>
    //                 ))}
    //             </ul>
    //         </div>
    //     </div>
    //     </div>
    // )

    return null;
}
export default CsMainUi;